export const _en = {
    code: {
        label: "Code service provider"
    },
    name: {
        label: "Name service provider"
    },
    description: {
        label: "Description"
    },
    refDivisionId: {
        label: "Division"
    },
    roleColor: {
        label: "Role representation color"
    }
};

export const _fr = {
    code: {
        label: "Code"
    },
    name: {
        label: "Nom du rôle"
    },
    description: {
        label: "Description"
    },
    refDivisionId: {
        label: "Service"
    },
    roleColor: {
        label: "Couleur de représentation du rôle"
    }
};